import RiskCompare from './RiskCompare';
import MarketRisk from './MarketRisk';
import InterestRates from './InterestRates';
import CreditSpreads from './CreditSpreads';
import FactorLens from './FactorLens';
import RiskBudget from './RiskBudget';
import PortfolioRisk from './PortfolioRisk';
import creditspreads_ from 'assets/img/landing-icons/rl-credit-spreads.png';
import factorlens_ from 'assets/img/landing-icons/rl-factor-lens.png';
import interestrates_ from 'assets/img/landing-icons/rl-interest-rates.png';
import marketrisk_ from 'assets/img/landing-icons/rl-market-risk.png';
import portfoliorisk_ from 'assets/img/landing-icons/rl-portfolio-risk.png';
import riskbudget_ from 'assets/img/landing-icons/rl-risk-budget.png';
import riskcompare_ from 'assets/img/landing-icons/rl-risk-compare.png';
import HorizontalLanding, { splitMeta } from 'components/HorizontalLanding';

export const meta = {
  path: '/rl',
  title: 'Risk Lab',
  component: Landing,
  items: [
    {
      path: '/risk-compare',
      title: 'Risk Compare',
      component: RiskCompare,
      description: 'Multiple asset comparison of exposures to equities, interest rates, and credit spreads.',
      imgSrc: riskcompare_,
      permission: 'rl-risk-compare',
    },
    {
      path: '/market-risk',
      title: 'Market Risk',
      component: MarketRisk,
      description: 'Perform in-depth analysis and equity risk decomposition of an asset or portfolio.',
      imgSrc: marketrisk_,
      permission: 'rl-market-risk',
    },
    {
      path: '/interest-rates',
      title: 'Interest Rates',
      component: InterestRates,
      description: 'Quantify interest rate exposure and measure key rate durations of an asset or portfolio.',
      imgSrc: interestrates_,
      permission: 'rl-interest-rates',
    },
    {
      path: '/credit-spreads',
      title: 'Credit Spreads',
      component: CreditSpreads,
      description: 'Quantify an asset or portfolio’s sensitivity to changing credit spreads and corporate bond yields.',
      imgSrc: creditspreads_,
      permission: 'rl-credit-spreads',
    },
    {
      path: '/factor-lens',
      title: 'Factor Lens',
      component: FactorLens,
      description: 'Quantify an asset’s risk exposures using a curated menu of over 200 risk and asset factors.',
      imgSrc: factorlens_,
      permission: 'rl-factor-lens',
    },
    {
      path: '/risk-budget',
      title: 'Risk Budget',
      component: RiskBudget,
      description:
        'Quantify the contribution to an asset’s risk budget using a curated menu of multi-factor risk models.',
      imgSrc: riskbudget_,
      permission: 'rl-risk-budget',
    },
    {
      path: '/portfolio-risk',
      title: 'Portfolio Risk',
      component: PortfolioRisk,
      description:
        'Identify and quantify a portfolio’s holdings-based risk and return contribution in addition to decomposing multifactor risk.',
      imgSrc: portfoliorisk_,
      permission: 'rl-portfolio-risk',
    },
  ],
};

const metas = splitMeta(meta, 2);

export default function Landing({ session }) {
  return metas.map((m, idx) => (
    <HorizontalLanding
      key={idx}
      meta={m}
      session={session}
      className={idx === 0 ? 'tw-pt-1 tw-pb-0' : 'tw-pt-0 tw-max-w-7xl'}
    />
  ));
}
